import { formatImperialHeight, formatImperialWeight, formatMetricHeight, formatMetricWeight, } from "@notemeal/shared-utils-macro-protocol";
import { useCallback } from "react";
import { useLocaleContext } from "./LocaleContext";
export const useAnthropometryFormatting = () => {
    const { isMetricLocale } = useLocaleContext();
    const formatHeight = useCallback((height) => {
        return isMetricLocale ? formatMetricHeight(height) : formatImperialHeight(height);
    }, [isMetricLocale]);
    const formatWeight = useCallback((weight) => {
        return isMetricLocale ? formatMetricWeight(weight) : formatImperialWeight(weight);
    }, [isMetricLocale]);
    const extractValuesFromAnthropometrySnapshot = useCallback((anthropometrySnapshot) => {
        const { weight, leanBodyMass, percentBodyFat, height, sex, age, weightInKg, leanBodyMassInKg, heightInCm } = anthropometrySnapshot;
        return isMetricLocale
            ? {
                weight: weightInKg,
                leanBodyMass: leanBodyMassInKg,
                percentBodyFat,
                height: heightInCm,
                age,
                sex,
            }
            : {
                weight,
                leanBodyMass,
                percentBodyFat,
                height,
                age,
                sex,
            };
    }, [isMetricLocale]);
    const extractValuesFromAnthropometryEntrySnapshot = useCallback((anthropometryEntrySnapshot) => ({
        ...extractValuesFromAnthropometrySnapshot(anthropometryEntrySnapshot),
        datetime: anthropometryEntrySnapshot.datetime,
    }), [extractValuesFromAnthropometrySnapshot]);
    return {
        formatHeight,
        formatWeight,
        extractValuesFromAnthropometrySnapshot,
        extractValuesFromAnthropometryEntrySnapshot,
    };
};
//# sourceMappingURL=useAnthropometryFormatting.js.map